export default "__VITE_ASSET__ca3c337d__"